import React, { useCallback, useContext, useEffect, useMemo } from 'react'
import ModalContext from 'contexts/ModalContext'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'
import MasterModalContext from 'contexts/MasterModalContext'
import { getHasLuxLoyaltyAccount, getIsLuxLoyaltyEnabled } from 'luxLoyalty/selectors/luxLoyaltyFeatureToggles'
import LuxLoyaltyJoinModal from 'luxLoyalty/components/LuxLoyaltyJoinModal'
import { clearLuxLoyaltyEnrolment } from 'actions/LuxLoyaltyActions'
import { isCustomerSupportMode } from 'selectors/featuresSelectors'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'

function useLuxLoyaltyEnrolNewUserModal() {
  const showModal = useContext(ModalContext)
  const loggedIn = useAppSelector(selectLoggedIn)
  const luxLoyaltyEnabled = useAppSelector(getIsLuxLoyaltyEnabled)
  const modalState = useContext(MasterModalContext)
  const hasLuxLoyaltyAccount = useAppSelector(getHasLuxLoyaltyAccount)
  const luxLoyaltyEnrolment = useAppSelector(state => state.luxLoyalty.enrolment)
  const customerSupportMode = useAppSelector(isCustomerSupportMode)

  const dispatch = useAppDispatch()
  const handleClearEnrolment = useCallback(() => dispatch(clearLuxLoyaltyEnrolment()), [dispatch])

  const shouldShowModal = loggedIn &&
  luxLoyaltyEnabled &&
  !modalState.open &&
  hasLuxLoyaltyAccount &&
  luxLoyaltyEnrolment === 'newUserRegistration' &&
  !customerSupportMode

  const primaryActionProps = useMemo<React.ComponentProps<typeof ModalFooter>['primaryActionProps']>(() => ({
    children: 'Start exploring',
    onClick: (_e, resolve) => resolve(),
  }), [])

  useEffect(() => {
    if (shouldShowModal) {
      showModal(<LuxLoyaltyJoinModal
        onAfterClose={handleClearEnrolment}
        primaryActionProps={primaryActionProps}
      />)
    }
  }, [handleClearEnrolment, primaryActionProps, shouldShowModal, showModal])
}

export default useLuxLoyaltyEnrolNewUserModal
